var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartSubtotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 3.9148H12.375C12.375 2.1247 10.8647 0.674805 9 0.674805C7.13531 0.674805 5.625 2.1247 5.625 3.9148H3.9375C3.00937 3.9148 2.25 4.6438 2.25 5.5348V15.2548C2.25 16.1458 3.00937 16.8748 3.9375 16.8748H14.0625C14.9906 16.8748 15.75 16.1458 15.75 15.2548V5.5348C15.75 4.6438 14.9906 3.9148 14.0625 3.9148ZM7.3125 7.1548C7.3125 7.6003 6.93281 7.9648 6.46875 7.9648C6.00469 7.9648 5.625 7.6003 5.625 7.1548V5.5348H7.3125V7.1548ZM9 2.2948C9.92812 2.2948 10.6875 3.0238 10.6875 3.9148H7.3125C7.3125 3.0238 8.07188 2.2948 9 2.2948ZM12.375 7.1548C12.375 7.6003 11.9953 7.9648 11.5312 7.9648C11.0672 7.9648 10.6875 7.6003 10.6875 7.1548V5.5348H12.375V7.1548Z",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSubtotal);
export default __webpack_public_path__ + "static/media/CartSubtotal.957699b24e586a09e56535f6817e7014.svg";
export { ForwardRef as ReactComponent };